import React, { useState } from 'react';
import { ResponsiveModal } from "../../../components/ResponsiveModal";
import { useResponsive } from "../../../contexts";
import { RadioButtonWithLabel, Typography, useGlobalContext } from 'seagull';
import { useStore, useStoreActions } from "../../../../store/store-context";
import sortBy from 'lodash/sortBy';
import { sendErrReport } from "../../../../infra/utils";
import styles from "./SwitchProposalBusiness.module.scss";
export function SwitchProposalBusiness(props) {
  const {
    relationshipId,
    onClose
  } = props;
  const {
    api,
    logBI
  } = useStoreActions();
  const email = useStore(state => {
    var _state$userInfo;

    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.email;
  });
  const worksAt = useStore(state => {
    var _state$userInfo2;

    return (_state$userInfo2 = state.userInfo) === null || _state$userInfo2 === void 0 ? void 0 : _state$userInfo2.worksAt;
  });
  const workspaces = useStore(state => {
    var _state$userInfo3;

    return (_state$userInfo3 = state.userInfo) === null || _state$userInfo3 === void 0 ? void 0 : _state$userInfo3.workspaces;
  });
  const {
    isDesktop
  } = useResponsive();
  const globalContext = useGlobalContext();
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
  const clientWorkspaces = sortBy(workspaces === null || workspaces === void 0 ? void 0 : workspaces.filter(ws => ws.features.accountsPayable), ws => ws.name);

  const onApproveBusinessChange = async () => {
    const shouldSwitchBusiness = selectedWorkspaceId && selectedWorkspaceId !== (worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);

    if (shouldSwitchBusiness) {
      logBI(10835, {
        companyName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
        email
      });

      try {
        await api.relationship.associateCustomer(relationshipId, selectedWorkspaceId);
        onClose(selectedWorkspaceId);
      } catch (err) {
        sendErrReport(err);
        globalContext.showErrorToast('Failed to assign a proposal to a different business', 'switch-business-failure-toast');
      }
    } else {
      onClose();
    }
  };

  return /*#__PURE__*/React.createElement(ResponsiveModal, {
    "data-testid": "switch-proposal-business-modal",
    title: "Assign proposal to a different business",
    mobileTitle: "Assign proposal to a different business",
    onClose: function (_onClose) {
      function onClose() {
        return _onClose.apply(this, arguments);
      }

      onClose.toString = function () {
        return _onClose.toString();
      };

      return onClose;
    }(() => onClose()),
    isDesktop: isDesktop,
    primaryButtonLabel: "Assign proposal",
    onPrimaryButtonClick: onApproveBusinessChange,
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => onClose()
  }, /*#__PURE__*/React.createElement(Typography, {
    as: "span"
  }, "This proposal is currently assigned to "), /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    as: "span",
    "data-testid": "current-company"
  }, worksAt === null || worksAt === void 0 ? void 0 : worksAt.name), /*#__PURE__*/React.createElement(Typography, {
    as: "span"
  }, " and a new business will be created once this proposal is signed."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, null, "If you believe this proposal is intended for an existing business, select the business to which this proposal should be assigned."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, "Select business:"), /*#__PURE__*/React.createElement("div", {
    className: styles.businessOptionsWrapper
  }, clientWorkspaces === null || clientWorkspaces === void 0 ? void 0 : clientWorkspaces.map(ws => {
    return /*#__PURE__*/React.createElement(RadioButtonWithLabel, {
      key: ws.id,
      label: ws.name,
      testId: "business-option",
      checked: selectedWorkspaceId === ws.id,
      onChange: () => setSelectedWorkspaceId(ws.id)
    });
  })));
}